/**
 * ⚠️：目前项目中所有的这种函数式调用的实现，都实现mount组件，这时所有props都是undefined
 * 再执行open的时候才会调用真正的prop，这时才有值，所以要特别注意这个情况
 */
import { createComponentInstance } from '@/utils/mount-component'
import { inBrowser } from '@/utils'
import BannedDialog from './BannedDialog.vue'

let instance

const DEFAULT_OPTIONS = {
  title: '',
  body: '',
  extra: '',
  buttonContent: '',
}

let currentOptions = Object.assign({}, DEFAULT_OPTIONS)

function initInstance() {
  instance = createComponentInstance(BannedDialog)
}

/**
 * 显示封禁弹窗
 * @param {Object} options - 配置选项
 * @param {String} options.title - 弹窗标题
 * @param {String} options.body - 弹窗内容
 * @param {String} options.extra - 额外提示
 * @param {String} options.buttonContent - 按钮文案
 * @param {Function} options.onConfirm - 确认回调
 * @param {Function} options.onClose - 关闭回调
 */
export function showBannedDialog(options = {}) {
  if (!inBrowser) {
    return
  }

  if (!instance) {
    initInstance()
  }

  const mergedOptions = Object.assign({}, currentOptions, options)
  const originalOnConfirm = mergedOptions.onConfirm
  const originalOnClose = mergedOptions.onClose
  const originalOnClosed = mergedOptions.onClosed

  instance.open(
    Object.assign({}, mergedOptions, {
      onConfirm: () => {
        originalOnConfirm?.()
      },
      onClose: () => {
        originalOnClose?.()
      },
      onClosed: () => {
        originalOnClosed?.()
        if (instance?.unmount) {
          instance.unmount()
          instance = null
        }
      },
    })
  )
}

/**
 * 关闭当前显示的封禁弹窗
 */
export function closeBannedDialog() {
  if (instance) {
    instance.toggle(false)
    // 关闭后由组件 watch(show) 触发 onClosed，进而 unmount 并移除 DOM
  }
}
